import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { HouseOneIcon, HouseTwoIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import {
  FamilyArrangementEnum,
  familyArrangementEnumMapping
} from '../../lib/types/enums/ol/family-arrangement.enum'
import InformationToolTip from './information-tooltip'

type Props = {
  familyArrangement?: FamilyArrangementEnum
}

const AccomodationTooltip = ({ familyArrangement }: Props) => {
  if (!familyArrangement) return <div className="flex items-center justify-center">-</div>

  return (
    <div className="flex items-center justify-center ">
      <InformationToolTip
        contentVariant="secondary"
        icon={
          <div
            className={cn('flex items-center justify-center w-7 h-7 bg-blue-light rounded-sm', {
              'bg-fushia-light': familyArrangement === FamilyArrangementEnum.FA2E
            })}
          >
            {familyArrangement === FamilyArrangementEnum.FA2E ? (
              <HouseTwoIcon color={tailwindColors.fushia.DEFAULT} />
            ) : (
              <HouseOneIcon color={tailwindColors.blue.DEFAULT} />
            )}
          </div>
        }
        size="small"
      >
        <Typography variant={'label-medium'} color={tailwindColors.black.DEFAULT}>
          {familyArrangementEnumMapping[familyArrangement].label}
        </Typography>
      </InformationToolTip>
    </div>
  )
}

export default AccomodationTooltip
